module.exports = __webpack_public_path__ + "img/snl-sc.7b566102.png";